(function($) {

    /* this is a 'render request' */
    $.fn.creRequest = function(options) {

        /* DEFAULTS */
        var settings,
            creXHR = { //really anything for exports
                settings: {}, // ... i don't thing used anymore
                rid: null, //defined if first successful
                //$currentPollReqXHR
                // cancelRenderReq: $.fn.creRequest.cancel
            },
            s = settings = {
                POLL_FREQ: 250,
                CRE_ROOT: 'http://localhost:8080/docview/viewer/',
                renderRequest: {
                    renderingParameters: {
                        containerType: 'raw', // , 'PDF', 'ZIP'  -- THIS IS THE FINAL OUTPUT TYPE FOR ALL 'PAGES'
                        pageType: 'raw',//, // raw, pdf, jpg, gif, png --> the format the image is output as : eg you could convert from the original
                        imageParameters: {
                            fixWidth: null,  //if NULL ignored --> DOT PER DOT  --
                            hdpi: null,          //i don't need
                            vdpi: null
                        },
                        pdfParameters: null, //(only want if pdf)
                        pageStamps: null
                    },
                    slices: [], //no defaults -- todo: check if passed in on validation ...
                    destinations: {  /* what you want to do with the file */
                        allowDownload: true  //allows the browser to download
                    }
                },
                fileName: 'file.pdf', //required for inline/download -- this is just the default -- optional for image
                completeCookie: null //(optional)
            },
            $vent = $({}),
            reqestCancelled = false, //flag
            $dfdPolling, //promise resolved / rejected when polling complete -- also abort on user cancel
            $currentPollReqXHR, //want global to abort
            stateRef = {
              'UNKNOWN': '',
              'AWAITING_EXECUTION': 'Waiting...',
              'EXECUTING_GATHERING_INFO': 'Gathering Info...',
              'EXECUTING_RENDERING': 'Rendering...',
              'EXECUTING_PACKAGING': 'Packaging...',
              'COMPLETE': 'Complete',
              'CANCELED_USER': 'User Cancelled',
              'CANCELED_ERROR': 'Error',
              'CANCELED_QUEUE_TIMEOUT': 'Request Timed Out',
              'CANCELED_ORPHAN': 'Request No Longer Available'
            };

        function validateOptions(options) {
            //TODO: required params
            //TODO: validate if jpg can only be 1 page in the pages array -- param validation
            options.CRE_ROOT = urlEndSlash(options.CRE_ROOT);
        }

        function sumbitRequest(renderRequest) {

            renderingRequest(renderRequest).done( function(renderStatus) {  //TODO: create a post render fn


                var rid = renderStatus.requestId;
                creXHR.rid = rid;

                $dfdPolling = new $.Deferred();

                $vent.on('cre.cancelRenderRequest', function(e, options) {
                    reqestCancelled = true;   //cancel the polling -- and flag to not enter succes
                    
                    $dfdPolling.resolve();
                    $currentPollReqXHR.abort(); //end the current status req
                    
                    cancelRenderReq(rid, options);
                } );

                // poll for completion
                $currentPollReqXHR = checkingRenderState(rid, $dfdPolling);
                creXHR.$currentPollReqXHR = $currentPollReqXHR; //put on there ... TODO: just use the obj

                $dfdPolling.done( function(renderStatus) { //note: stateDesc already added
                    
                    if (reqestCancelled) {
                        cleanUp();
                        return false;
                    }

                    var rid = renderStatus.requestId; //rid could be undefined if request cancelled
                    s.onComplete && s.onComplete({
                        renderStatus: renderStatus,
                        imgUrl: getBaseUrl(rid, s.fileName),
                        inlineUrl: downloadUrl(rid , true, s.fileName, s.completeCookie),
                        downloadUrl: downloadUrl(rid , false, s.fileName, s.completeCookie)
                    });

                    cleanUp();

                }).fail(function(renderStatus) { //any of the cancels or unknown -- IF USER CANCELLED, WILL BE jqXHR OR renderStatus
                    
                    if (reqestCancelled || $currentPollReqXHR.status === 0) return;  //don't handle error if user cancel -- its handled separately --
                    handlerErr('render', renderStatus);

                });

            }).fail(function(jqXHR) {
                  handlerErr('network', jqXHR);
            });
        }

        function renderingRequest(renderReq) {
            return $.ajax({
                url: s.CRE_ROOT + 'rest/v2/api/cre',
                type: 'POST',
                contentType: 'application/json', ///json necessary for express.js
                data: JSON.stringify(renderReq)
            }).promise();
        }

        function checkingRenderState(requestId, $dfdDone) {

            var checkStateTimer;

            return $.ajax({
                url: s.CRE_ROOT + 'rest/v2/api/cre/' + requestId + '/status',
                type: 'GET'
            }).done( function(renderStatus) { //this should be in diff fn -- loop check render state

                var state = renderStatus.state;
                renderStatus['stateDesc'] = stateRef[state]; //add a friendly desc to the resp for use in oncheckstate
                s.onCheckState && s.onCheckState(renderStatus);

                //user cancelled trapped by plugin (don't catch here)
                if ( (state.indexOf('CANCEL') > -1 || state === 'UNKNOWN') && state !=='CANCELED_USER') {
                    clearTimeout(checkStateTimer);
                    $dfdDone.reject(renderStatus);
                } else if (state === 'COMPLETE') {
                    // TODO: MAY NEED QUEUE IN CASE MULTI GOING ON AT SAME TIME AND THEY OVERLAP EACHOTHER
                    clearTimeout(checkStateTimer);
                    // $currentPollReqXHR.abort(); //prevent any called in between poll freq?
                    $dfdDone.resolve(renderStatus);
                } else if (state !=='CANCELED_USER') {  //poll -- still disallow cancelled user

                    checkStateTimer = setTimeout( function () {
                        reqestCancelled
                            ? clearTimeout(checkStateTimer)
                            : $currentPollReqXHR = checkingRenderState(renderStatus.requestId, $dfdDone); //recursion
                    }, s.POLL_FREQ );

                }

            }).fail(function(jqXHR) {  //regular failure
                clearTimeout(checkStateTimer);
                $dfdDone.reject(jqXHR);  //(this can pick up user cancelled / aborted)
            }); //return the xhr to abort on cancel
        }

        function cancelRenderReq(rid, options) {
            return $.ajax({
                url: s.CRE_ROOT + 'rest/v2/api/cre/' + rid,
                type: 'DELETE'
            }).done( function(renderStatus) {

                settings.onCancel && settings.onCancel(renderStatus, options);

            }).fail(function(jqXHR, options) {
                settings.onCancelError && settings.onCancelError('Error Cancelling Render Request: ' + jqXHR.status + ' ' + jqXHR.statusText + ' -- ' + jqXHR.responseText, options);
            });
        }

        /* normalize error callbacks render, network, userCancel err */
        /* type is 'render' --> renderStatus object, or 'network' --> */
        function handlerErr(errType, errObj) {
            var fnErr = s.onError;
            if (fnErr) {
                switch(errType) {
                    case 'render':
                        fnErr(errObj.text); //(renderStatus)
                        break;
                    case 'network':
                        fnErr(errObj.status + ' ' + errObj.statusText + ' -- ' + errObj.responseText); //(jqXHR)
                        break;
                }
            }
            cleanUp();
        }

        function getBaseUrl(rid, filename) {

            var u = s.CRE_ROOT + 'rest/v2/api/cre/' + rid + '/download/';

            if (filename)
                u += encodeURIComponent(filename);

            return u;
        }

        /* inline or download */
        function downloadUrl(rid, isInline, filename, completeCookie) {

            var u = getBaseUrl(rid, filename) + '?inline=' +  String(isInline);
            if (completeCookie)
                u += '&cookieName=' + encodeURIComponent(completeCookie);

            return u;
        }

        function cleanUp() {
            $vent.off('cre.cancelRenderRequest');
        }

        /* Expose Public fn on namespace to cancel;
          * param: distinguish between user cancel and force cancel (options.forceCancel -- eg session timeout)
        */

        /* TODO: NEED A QUEUE -- EG: THESE FNS WILL ONLY EXIST IF A REQUEST HAS BEEN MADE -- WANT AN OPTION TO CANCEL ALL */
        /* or -- return a ref for each --- */

        //todo: now call from cancelRenderReq and remove these

        $.fn.creRequest.cancel = function(options) {
            $vent.trigger('cre.cancelRenderRequest', options );
        };

         creXHR.cancel = $.fn.creRequest.cancel;


        $.fn.creRequest.pollInterval = function() {
            return s.POLL_FREQ;
        };

        function init(options) {
            validateOptions(options);
            $.extend(true, s, options);
            creXHR.settings = s.renderRequest;
            s.onStart && s.onStart();
            sumbitRequest(s.renderRequest);
        }

        init(options);

        return creXHR; //this is jquery -- jq returns a jqxhr

    };

    /* Helpers */
    function urlEndSlash(url) {
        var lastChar = url.charAt(url.length-1);
        url = (lastChar !== '/') ? url  + '/' : url;
        return url;
    }


})(jQuery);

/*** EXPORTS FROM exports-loader ***/
module.exports = $.fn.creRequest;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/CRE-plugin/jquery.cre.js
 ** module id = 389
 ** module chunks = 0
 **/